import type { FaireProductEntity } from "../../entity_types/product";

export const p_6dbuhze2n5: FaireProductEntity = {
  token: "p_6dbuhze2n5",
  type: "product",
  name: "Minute Maid Peach Drink 12/450mL (CHINA)",
  brandToken: "b_ktcqb4hfg7",
  brandName: "L&F Universal Goods",
  imageUrl:
    "https://cdn.faire.com/fastly/434510fa3eb1fa6a24ea1f5af3a2f4c631ecf18141951f1a7c503355cad19fe2.jpeg",
  galleryImageUrls: [],
  priceDollars: 38.8,
  description:
    "Minute Maid Peach Drink 12/450mL (CHINA) – Smooth peach juice beverage combining sweetness and aroma for a fruity delight.",
  tags: [],
  msrpDollars: 77.6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:24.222Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
